/**
 * #41 (ESERV2-1448) — Send and Receive show one row per ORDER with a tab per
 * vendor PO: "one order number and then all the vendors for that. So you're
 * always tracking the same order across all tabs."
 *
 * The parent comes from fk_order_id (written by /finalize since this ticket);
 * legacy POs fall back to parsing the label — "PREFIX-146-1" → 146, where the
 * trailing "-1" is the per-vendor index /finalize appends. A PO with neither
 * stands alone rather than being guessed into someone else's order.
 */

export function parseOrderIdFromPoLabel(poLabel) {
  const match = /(\d+)-\d+$/.exec(String(poLabel ?? "").trim());
  return match ? Number(match[1]) : null;
}

export function orderIdForPo(po) {
  if (po?.fk_order_id != null) return Number(po.fk_order_id);
  return parseOrderIdFromPoLabel(po?.po);
}

export function groupPosByOrder(pos) {
  const groups = new Map();
  for (const po of pos ?? []) {
    const orderId = orderIdForPo(po);
    const key = orderId != null ? `order-${orderId}` : `po-${po.id}`;
    const group = groups.get(key);
    if (group) {
      group.pos.push(po);
    } else {
      groups.set(key, { key, orderId, pos: [po] });
    }
  }
  return [...groups.values()];
}
